import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

export interface EmailUsageResponse {
  emailsSent: number;
  monthlyLimit: number;
  percentageUsed: number;
}

const useGetEmailUsage = (options?: QueryOptions<EmailUsageResponse>) => {
  const user = useUser();

  return useUserQuery<EmailUsageResponse>(
    { path: `/api/businesses/${user.selectedBusiness?.id!}/widgets/emailUsage` },
    options);
}

export default useGetEmailUsage;